import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { canonicalPathname } from '@/lib/canonicalPath';

/**
 * Normalizes browser navigation, preserving queries and fragments.
 * This is client navigation, not a hosting-level HTTP permanent redirect.
 */
const TrailingSlashRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;
    const canonical = canonicalPathname(pathname);
    if (canonical === pathname) return;
    navigate(`${canonical}${search}${hash}`, { replace: true });
  }, [location, navigate]);

  return null;
};

export default TrailingSlashRedirect;
